import { type Ad } from '@/entities/ad-banner/model/wrapper-ads.types';

import { type ExtraValues, type PlatformEvent } from '../types';

export const showAdEvent = (ad: Ad, extra?: ExtraValues): PlatformEvent => {
  return {
    type: 'show',
    user_properties: {},
    event_properties: {
      name: 'ad',
      id: ad.id,
      image: ad.image,
      advertiser: ad.advertiser,
      ...(extra && { ...extra.event_properties }),
    },
  };
};
